import { Component, OnInit } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,HttpErrorResponse } from '@angular/common/http';
import 'rxjs/add/operator/map';
import { ActivatedRoute, Router } from '@angular/router';
import { LocalStorageService } from 'ngx-webstorage';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from "ngx-spinner";
import { DtoService } from '../../services/dto.service';
import { UtilService } from '../../services/util.service';
import { FunctService } from '../../services/funct.service';
import { TranslateService } from '@ngx-translate/core';
import { catchError, ignoreElements, retry } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { CommonService } from '../../services/common.service';

@Component({
  selector: 'game-account-login',
  templateUrl: './game-account-login.component.html',
  styleUrls: ['./game-account-login.component.css']
})
  
export class GameAccountLoginComponent implements OnInit {

  token: any;
  userProfileModel: any;
  isUserLoggedIn: any;
  showAmount: boolean = true;
  showJLAmount : boolean = true;
  showQCAmount : boolean = true;
  showBalance: any;
  showCQBalance : any;
  showJILIBalance : any;
  deviceId: any;
  providerId: any;
  gameUserBalance: any;
  loadingGameBalance: any;
  parentLink: any;
  loadingBalance: any;

  routerName: any;
  loadingJLBalance: boolean;
  loadingCQBalance: boolean;

  constructor(
    private translateService: TranslateService,
    private toastr: ToastrService,
    private spinner: NgxSpinnerService,
    private dto: DtoService,
    private http: HttpClient,
    private util: UtilService, 
    private route: ActivatedRoute,
    private router: Router,
    private storage: LocalStorageService,
    private funct: FunctService,
    private common: CommonService) {
      this.routerName = this.router.url;
      
      this.isUserLoggedIn = this.storage.retrieve('isUserLoggedIn');
      this.deviceId = this.storage.retrieve('localDeviceId');  
      this.showAmount =  this.storage.retrieve('showAmount');
      
      this.token = this.storage.retrieve('token');
    
      if (this.storage.retrieve('localShowBalance') == null) {
        this.storage.store('localShowBalance', true); 
      }
    
  }
  
  ngOnInit(): void {
      
      this.providerId = this.route.snapshot.paramMap.get("providerId"); 
      this.parentLink = "/gameList/"+this.providerId;
      this.userProfileModel = {
        balance: '',
        imageUrl: '',
        name: '',
        phone_no: '',
        referral_code: ''
      }
     
      if (this.isUserLoggedIn) {
        this.getUserProfile();
        if(this.providerId != 11)
        {
          this.getGameUserBalance();
        }
        else
        {
          this.getGameUserBlanceCQFish();
          this.getGameUserBlanceJILIFish();
        }
      }
     
  }
  
  loginAccount(){
    if(this.deviceId != null){
      this.router.navigate(['/auth/login',this.deviceId]);
      return;
    }
    this.router.navigate(['/auth/login'])
  }

  handleError(error: HttpErrorResponse) {
    this.loadingBalance = false;
    this.loadingJLBalance = false;
    this.spinner.hide('loadingBalance');
    if(error.status == 0) {
      this.common.errorMsg("", "checkInternet", "top");
    }
    if(error.status == 423) {
      this.common.errorMsg("", "youNeedLogin", "top");
      this.storage.clear('token');
      this.storage.clear('isUserLoggedIn');
    }
    if(error.status == 400) {
      this.common.errorMsg("", "bad_request", "top");
    }
    return throwError(error);
  }
    
  getUserProfile() {
    this.token = this.storage.retrieve('token');  
    let headers = new HttpHeaders();
    headers = headers.set('Authorization', this.token);
    
    this.http.get(this.funct.ipaddress + 'user/PointUserProfile', { headers: headers })
    .pipe(
      catchError(this.handleError.bind(this))
    )
    .subscribe(
      result => {          
        this.userProfileModel = result;
        this.storage.store("userProfileBalance", this.userProfileModel.balance);
    });
  } 
  
  toggleAmount(show: boolean) {
    this.showAmount = show;
    this.storage.store('showAmount', show);
    this.storage.store('localShowBalance', this.showAmount);
  }

  toggleJLAmount(show : boolean)
  {
    this.showJLAmount = show;
    this.storage.store('showJLAmount', show);
    this.storage.store('localShowBalance', this.showJLAmount);
  }
  toggleCQAmount(show : boolean)
  {
    this.showQCAmount = show;
    this.storage.store('showQCAmount', show);
    this.storage.store('localShowBalance', this.showCQBalance);
  }
  openWalletPage() {
    this.router.navigate(['/wallet']);  
  }

  async getGameUserBalance() {     
    
    this.loadingBalance = true;
    this.spinner.show('balanceLoading');

    this.token = this.storage.retrieve('token');
    let config = {
      headers: {'Authorization': this.token},
      params: {'providerId': this.providerId},
    }
    const axios = require('axios').default;

    const url = this.providerId === '8' ? `shkm/getBalance` : 'loginGS/getBalance'
    
    await axios.get(this.funct.ipaddress + url, config )
    .then((res) => {
      // this.isUserLoggedIn = true;
      // this.gameUserBalance = res.data.balance;
      this.showBalance = this.providerId === '8' ? res.data.data : res.data.balance;

      this.loadingBalance = false;
      this.spinner.hide('balanceLoading');

      // if (this.showAmount) {
      //   this.showBalance = this.gameUserBalance; 
      //   this.loadingBalance=false;
      //   this.spinner.hide('loadingBalance'); 
      // }
    
      // this.loadingGameBalance=false;
      // this.spinner.hide('gameBalanceSpinner');
      //Added this
      this.storage.store('localGameBalanceBefore',this.showBalance);
      return res.data.balance;
    })
    .catch((error) => { 
    
      this.loadingBalance = false;
      this.spinner.hide('balanceLoading');
  
      // this.isUserLoggedIn = false; 
      // this.loadingGameBalance = false;
      // this.spinner.hide('gameBalanceSpinner');
      if (error.response) {
        return;
      }
    });
  }
  
  //For Two Fishes
  async getGameUserBlanceCQFish() {     
    
    this.loadingCQBalance = true;
    this.spinner.show('balanceLoading');

    this.token = this.storage.retrieve('token');
    let config = {
      headers: {'Authorization': this.token},
      params: {'providerId': 4},
    }
    const axios = require('axios').default;

    const url = this.providerId === '8' ? `shkm/getBalance` : 'loginGS/getBalance'
    
    await axios.get(this.funct.ipaddress + url, config )
    .then((res) => {
      // this.isUserLoggedIn = true;
      // this.gameUserBalance = res.data.balance;
      //this.showBalance = this.providerId === '8' ? res.data.data : res.data.balance;
      this.showCQBalance = this.providerId === '8' ? res.data.data : res.data.balance;
      this.loadingCQBalance = false;
      this.spinner.hide('balanceLoading');
      //Added this
      this.storage.store('localGameBalanceBefore',this.showCQBalance);
      return res.data.balance;
    })
    .catch((error) => { 
    
      this.loadingBalance = false;
      this.spinner.hide('balanceLoading');
  
      // this.isUserLoggedIn = false; 
      // this.loadingGameBalance = false;
      // this.spinner.hide('gameBalanceSpinner');
      if (error.response) {
        return;
      }
    });
  }
  async getGameUserBlanceJILIFish() {     
    
    this.loadingJLBalance = true;
    this.spinner.show('balanceLoading');

    this.token = this.storage.retrieve('token');
    let config = {
      headers: {'Authorization': this.token},
      params: {'providerId': 5},
    }
    const axios = require('axios').default;

    const url = this.providerId === '8' ? `shkm/getBalance` : 'loginGS/getBalance'
    
    await axios.get(this.funct.ipaddress + url, config )
    .then((res) => {
      //this.showBalance = this.providerId === '8' ? res.data.data : res.data.balance;
      this.loadingJLBalance = false;
      this.spinner.hide('balanceLoading');
      this.showJILIBalance = this.providerId === '8' ? res.data.data : res.data.balance;
      //Added this
      this.storage.store('localGameBalanceBefore',this.showJILIBalance);
      return res.data.balance;
    })
    .catch((error) => { 
      this.loadingBalance = false;
      this.spinner.hide('balanceLoading');
      if (error.response) {
        return;
      }
    });
  }
//Ends
//Original for all game
selectGameListId() { 
  var localGameProviderList = this.storage.retrieve("localGameProviderList");
  var objProvider = localGameProviderList.find(x => x.isMaintenance  && x.provider_id == this.providerId);
  if(objProvider != undefined)
  {
    var providerName = objProvider.display_name;
    this.common.errorMsg("", "", "top", providerName + this.translateService.instant("undermaintenance"));
    return;
  }
  else
  {
  sessionStorage.setItem('gameProviderId', "ProviderId");
  this.router.navigate(['/game/wallet'], {state: {selectGameAccount: this.providerId, parentLink: "/gameList/"+this.providerId},replaceUrl: false});
  }
}

 selectFishGameListId(providerId) { 
    var localGameProviderList = this.storage.retrieve("localGameProviderList");
    var objProvider = localGameProviderList.find(x => x.isMaintenance  && x.provider_id == providerId);
    if(objProvider != undefined)
    {
      var providerName = objProvider.display_name;
      this.common.errorMsg("", "", "top", providerName + this.translateService.instant("undermaintenance"));
      return;
    }
    else
    {
    sessionStorage.setItem('gameProviderId', "ProviderId");
    this.router.navigate(['/game/wallet'], {state: {selectGameAccount: providerId, parentLink: "/gameList/"+providerId},replaceUrl: false});
    }
 }

  goToNotiList() {
    this.router.navigate(['/notification/list'],{state: {parentLink: this.parentLink},replaceUrl: true});
  }

  goToProfileDetail() {
    this.router.navigate(['/profile/detail'], { replaceUrl: false });
  }

  login(){
    if(this.deviceId != null){
      this.router.navigate(['/auth/welcome',this.deviceId],{ state: {parentLink: this.parentLink}, replaceUrl: true });
      return;
    }
    this.router.navigate(['/auth/welcome'],{ state: {parentLink: this.parentLink}, replaceUrl: true })
  }
  
}
